import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {EmployeeService} from "../../../../shared/services/employee.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../../shared/services/auth.service";
import {UserService} from "../../../../shared/services/user.service";
import {takeUntil} from "rxjs/operators";
import {Employee, LeaveApplication} from "../../../../shared/interface/employee";
import {HttpErrorResponse} from "@angular/common/http";
import {LeaveApplicationService} from "../../../../shared/services/leave-application.service";

@Component({
  selector: 'app-leave-application-details',
  templateUrl: './leave-application-details.component.html',
  styleUrls: ['./leave-application-details.component.scss']
})
export class LeaveApplicationDetailsComponent implements OnInit, OnDestroy {

  leaveApplicationId: string;
  userPermissions: any;
  leaveApplicationObject?: LeaveApplication;
  leaveApplication: ReplaySubject<LeaveApplication> = new ReplaySubject<LeaveApplication>(1);
  modify = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  constructor(
    private route: ActivatedRoute,
    private leaveApplicationService: LeaveApplicationService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private userService: UserService
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.leaveApplicationId = params.id;
        this.loadLeaveApplication();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadLeaveApplication(): void {
    this.leaveApplicationService.get(this.leaveApplicationId).subscribe((leaveApplication: LeaveApplication) => {
      this.leaveApplication.next(leaveApplication);
      this.leaveApplicationObject = leaveApplication;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }

}
